import { DirtyFieldsType, Operation } from '@occc-app/offerHelpers/types';
import { getCustomDataFromFormValues, isFieldDirty } from '@occc-app/offerHelpers/utils';
import { makeOfferUpdateOperation } from '@occc-app/offerHelpers/operations/makeOfferUpdateOperation';
import { Custom_Data_Mode, CustomDataInput } from '@occc/graphql';
import { CustomDataFormValues } from '@occc/validation';

export type GetOfferCustomDataOperationsParams = {
  offerId: string;
  dirtyFields: DirtyFieldsType;
  values: { customData?: CustomDataFormValues; [key: string]: any };
};

export const getOfferCustomDataOperation = ({
  dirtyFields,
  values,
  offerId,
}: GetOfferCustomDataOperationsParams): Operation | null => {
  const isCustomDataFieldDirty = isFieldDirty<{ customData?: CustomDataFormValues }>(
    dirtyFields,
    'customData',
  );

  if (!isCustomDataFieldDirty) {
    return null;
  }

  const customData = getCustomDataFromFormValues(values.customData);
  let customDataInput: CustomDataInput | null = null;
  if (values.customData?.isEnabled && customData) {
    customDataInput = { data: customData, mode: Custom_Data_Mode.Replace };
  }

  return makeOfferUpdateOperation(offerId, {
    customData: customDataInput,
  });
};
